export const UPDATE_PROMOS = "UPDATE_PROMOS";
export const SET_PROMOS_SEARCH = "SET_PROMOS_SEARCH";
export const SET_PROMOS_ISSUE_FILTER = "SET_PROMOS_ISSUE_FILTER";
export const UPDATE_PROMOTION_DETAIL = "UPDATE_PROMOTION_DETAIL";
export const SET_PROMOTION_DETAIL_LOADING = "SET_PROMOTION_DETAIL_LOADING";
export const RESET_PROMOTION_DETAIL = "RESET_PROMOTION_DETAIL";
export const SET_DISCOUNT_DETAILS_SEARCH = "SET_DISCOUNT_DETAILS_SEARCH";
export const SET_PROMOTION_STAGES_LOADING = "SET_PROMOTION_STAGES_LOADING";
export const UPDATE_PROMOTION_EVENTS = "UPDATE_PROMOTION_EVENTS";
export const SET_PROMOTION_EVENTS_LOADING = "SET_PROMOTION_EVENTS_LOADING";
export const SET_PROMOTION_EVENTS_SEARCH = "SET_PROMOTION_EVENTS_SEARCH";
export const SET_PROMOTION_EVENTS_PAGINATION = "SET_PROMOTION_EVENTS_PAGINATION";
export const UPDATE_PROMOTION_ISSUES = "UPDATE_PROMOTION_ISSUES";
export const SET_PROMOTION_ISSUES_LOADING = "SET_PROMOTION_ISSUES_LOADING";
export const UPDATE_PROMOTION_DELIVERIES = "UPDATE_PROMOTION_DELIVERIES";
export const SET_PROMOTION_DELIVERIES_LOADING = "SET_PROMOTION_DELIVERIES_LOADING";
export const OPEN_DISCOUNT_DETAILS_DRAWER = "OPEN_DISCOUNT_DETAILS_DRAWER";
export const CLOSE_DISCOUNT_DETAILS_DRAWER = "CLOSE_DISCOUNT_DETAILS_DRAWER";
export const UPDATE_DISCOUNT_DETAILS = "UPDATE_DISCOUNT_DETAILS";
export const UPDATE_DISCOUNT_DETAILS_DATA = "UPDATE_DISCOUNT_DETAILS_DATA";
export const SET_DISCOUNT_DETAILS_LOADING = "SET_DISCOUNT_DETAILS_LOADING";
export const UPDATE_DISCOUNT_ACTIVE_STATUS = "UPDATE_DISCOUNT_ACTIVE_STATUS";
export const OPEN_CLIENT_DISCOUNT_DRAWER = "OPEN_CLIENT_DISCOUNT_DRAWER";
export const CLOSE_CLIENT_DISCOUNT_DRAWER = "CLOSE_CLIENT_DISCOUNT_DRAWER";
// Cross-component filter state — the lifecycle widget's stat tiles drive
// the discount details grid below it. Value is one of:
//   'ERROR' | 'WARNING' | 'disabled' | null
export const SET_LIFECYCLE_FILTER = "SET_LIFECYCLE_FILTER";
export const UPDATE_PROMOTION_OWNER = "UPDATE_PROMOTION_OWNER";
export const UPDATE_PROMOTION_ASSIGNEE = "UPDATE_PROMOTION_ASSIGNEE";
export const REVERT_PROMOTION_OWNER = "REVERT_PROMOTION_OWNER";
export const REVERT_PROMOTION_ASSIGNEE = "REVERT_PROMOTION_ASSIGNEE";
// Delivery drawer
export const OPEN_DELIVERY_DRAWER = "OPEN_DELIVERY_DRAWER";
export const CLOSE_DELIVERY_DRAWER = "CLOSE_DELIVERY_DRAWER";
export const UPDATE_DELIVERY_NOTES = "UPDATE_DELIVERY_NOTES";
export const SET_DELIVERY_NOTES_LOADING = "SET_DELIVERY_NOTES_LOADING";
// Grid preferences
export const UPDATE_GRID_PREFERENCES = "ppt/UPDATE_GRID_PREFERENCES";
export const REVERT_GRID_PREFERENCES = "ppt/REVERT_GRID_PREFERENCES";
export const GRID_PREFERENCES_REQUESTED = "ppt/GRID_PREFERENCES_REQUESTED";
export const GRID_PREFERENCES_LOADED = "ppt/GRID_PREFERENCES_LOADED";
export const GRID_PREFERENCES_FAILED = "ppt/GRID_PREFERENCES_FAILED";
